import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Section, Eyebrow, Reveal } from "./shared";
import { OBJECTIONS } from "../../lib/site";

export default function Objections() {
  const [open, setOpen] = useState(null);
  return (
    <Section id="objections" bg="bg-white">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#E90019">Honest Answers</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">You May Be Thinking…</h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-x-6 gap-y-3 mt-12">
        {OBJECTIONS.map((o, i) => {
          const active = open === i;
          return (
            <Reveal key={o.q} delay={(i % 2) * 0.04}>
              <div className={`rounded-[18px] border-2 border-brand-black overflow-hidden ${active ? "bg-brand-cream" : "bg-white"}`}>
                <button onClick={() => setOpen(active ? null : i)} data-testid={`objection-toggle-${i}`} aria-expanded={active}
                  className="w-full flex items-center justify-between gap-3 p-4 sm:p-5 text-left">
                  <span className="font-semibold text-sm sm:text-base">{o.q}</span>
                  <ChevronDown size={18} className={`shrink-0 transition-transform ${active ? "rotate-180 text-brand-red" : ""}`} />
                </button>
                <AnimatePresence initial={false}>
                  {active && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
                      <p className="px-4 sm:px-5 pb-5 text-sm text-brand-ink/75 leading-relaxed">{o.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
}
